import React from 'react';
export const VipModuleSection = () => {
  const levels = [{
    title: 'LEVEL 1 — BEGINNER',
    color: 'text-familia-green',
    items: ['For older adults with limited mobility or who need greater assistance.', 'Seated or bed-based exercises.', 'Basic recognition and cognitive engagement activities.', 'Gentle mobility activities.', '50 physical and cognitive activities.']
  }, {
    title: 'LEVEL 2 — INTERMEDIATE',
    color: 'text-blue-400',
    items: ['For older adults who can participate with support or supervision.', 'Supported strength and balance exercises.', 'Everyday logic and calculation activities.', 'Coordination and mobility exercises.', '50 physical and cognitive activities.']
  }, {
    title: 'LEVEL 3 — ADVANCED',
    color: 'text-purple-400',
    items: ['For independent and active older adults.', 'Coordination and endurance exercises.', 'Higher-level mental challenges.', 'Functional movement activities.', '50 physical and cognitive activities.']
  }];
  return <section id="vip" className="bg-familia-section py-10 md:py-16 px-4 md:px-6" data-id="element-279">
      <div className="max-w-7xl mx-auto w-[92%] md:w-full" data-id="element-280">
        <div className="text-center mb-10 md:mb-16" data-id="element-281">
          <h2 className="text-[22px] sm:text-3xl md:text-5xl font-display font-bold mb-4 md:mb-6" data-id="element-282">
            ⚡ PLUS THE EXCLUSIVE VIP MODULE
          </h2>
          <p className="text-familia-cyan font-bold text-lg md:text-xl mb-4" data-id="element-283">
            VIP Module — 150+ At-Home Physical and Cognitive Exercises
          </p>
          <p className="text-familia-gray text-[15px] md:text-lg max-w-3xl mx-auto leading-relaxed" data-id="element-284">
            The heart of the Master Kit. 150+ physical and cognitive activities
            organized into 3 adaptation levels based on each older adult's
            actual abilities. You'll never run out of activities. You'll never
            have to improvise again.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-285">
          {levels.map((level, i) => <div key={i} className="bg-familia-card border border-white/5 p-6 md:p-8 rounded-2xl" data-id="element-286">
              <h3 className={`text-lg md:text-xl font-bold mb-6 ${level.color}`} data-id="element-287">
                {level.title}
              </h3>
              <ul className="space-y-4" data-id="element-288">
                {level.items.map((item, j) => <li key={j} className="flex items-start gap-3 text-sm md:text-base text-white/90" data-id="element-289">
                    <span className={`${level.color} shrink-0`} data-id="element-290">→</span>
                    <span data-id="element-291">{item}</span>
                  </li>)}
              </ul>
            </div>)}
        </div>
      </div>
    </section>;
};